import { Typography } from '@mui/material'
import { WorkflowStateAction } from '@/types/workflow-state-actions'
import { useGetProjectLinkedModel } from '@/service-library/hooks/project-linked-models'
import PrimaryTextWrapper from './PrimaryTextWrapper'

type RunPredictionLinkedModelDisplayProps = {
  action: WorkflowStateAction
}

export default function RunPredictionLinkedModelDisplay({
  action,
}: RunPredictionLinkedModelDisplayProps) {
  const { projectLinkedModel, isLoading } = useGetProjectLinkedModel({
    id: action.params.linked_model_id,
    filters: {
      fields__only: 'id,project_model',
      projecT_model__fields__only: 'name',
    },
  })

  if (isLoading) return null

  return (
    <Typography variant="body2" color="text.secondary">
      Run the{' '}
      <PrimaryTextWrapper>
        {projectLinkedModel?.project_model?.name}
      </PrimaryTextWrapper>{' '}
      prediction model.
      {action.params.flag_if_no_model_version
        ? " If there isn't a model version available, the document will be flagged with an info flag."
        : ''}
    </Typography>
  )
}
